import globalAxios from 'axios';
import { createRequestFunction, assertParamExists, DUMMY_BASE_URL, setSearchParams, toPathString } from '../common.mjs';
import { BASE_PATH } from '../base.mjs';
import { makeRemoteWithOpenapiGenerator } from '@flex-packages/remote-core';

const UserSearchControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @summary ID를 이용하여 구성원을 검색합니다.
     * @param {UserSearchControllerApiSearchUserByIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchUserByIds: ({ customerIdHash, userIdHashes }, options = {}) => {
      assertParamExists("searchUserByIds", "customerIdHash", customerIdHash);
      assertParamExists("searchUserByIds", "userIdHashes", userIdHashes);
      const localVarPath = `/api/v2/search/customers/{customerIdHash}/search-users/{userIdHashes}`.replace(`{${"customerIdHash"}}`, encodeURIComponent(String(customerIdHash))).replace(`{${"userIdHashes"}}`, encodeURIComponent(String(userIdHashes)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        ...localVarRequestOptions,
        identifier: "searchUserByIds",
        url: toPathString(localVarUrlObj)
      };
    },
    /**
     * 
     * @summary ID를 이용하여 구성원을 검색합니다.
     * @param {UserSearchControllerApiTimeSeriesSearchUserByIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    timeSeriesSearchUserByIds: ({ customerIdHash, userIdHashes }, options = {}) => {
      assertParamExists("timeSeriesSearchUserByIds", "customerIdHash", customerIdHash);
      assertParamExists("timeSeriesSearchUserByIds", "userIdHashes", userIdHashes);
      const localVarPath = `/api/v2/search/customers/{customerIdHash}/time-series/search-users/{userIdHashes}`.replace(`{${"customerIdHash"}}`, encodeURIComponent(String(customerIdHash))).replace(`{${"userIdHashes"}}`, encodeURIComponent(String(userIdHashes)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        ...localVarRequestOptions,
        identifier: "timeSeriesSearchUserByIds",
        url: toPathString(localVarUrlObj)
      };
    }
  };
};
const UserSearchControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = UserSearchControllerApiAxiosParamCreator();
  return {
    /**
     * 
     * @summary ID를 이용하여 구성원을 검색합니다.
     * @param {UserSearchControllerApiSearchUserByIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchUserByIds(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.searchUserByIds(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    },
    /**
     * 
     * @summary ID를 이용하여 구성원을 검색합니다.
     * @param {UserSearchControllerApiTimeSeriesSearchUserByIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    timeSeriesSearchUserByIds(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.timeSeriesSearchUserByIds(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    }
  };
};
makeRemoteWithOpenapiGenerator({
  requestArgsCreator: UserSearchControllerApiAxiosParamCreator().searchUserByIds,
  requestFn: UserSearchControllerApiFp().searchUserByIds
});
const timeSeriesSearchUserByIdsRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: UserSearchControllerApiAxiosParamCreator().timeSeriesSearchUserByIds,
  requestFn: UserSearchControllerApiFp().timeSeriesSearchUserByIds
});

export { UserSearchControllerApiAxiosParamCreator, UserSearchControllerApiFp, timeSeriesSearchUserByIdsRemote };
//# sourceMappingURL=user-search-controller-api.mjs.map
